import React from 'react'
import { Button, Stack } from '@mui/material'
import ModalConfirmar from './commons/ModalConfirmar'
import colors from '../theme/colors'
import { useTranslation } from "react-i18next"
import { TooltipButton } from './commons/TooltipButton'
import { ToolTipBoton } from './commons/ToolTipBoton'
import { BotonPDF } from './commons/BotonPDF'
import ReplayIcon from '@mui/icons-material/Replay';
import ClearIcon from '@mui/icons-material/Clear'
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew'
import { styled } from '@mui/material/styles'
import LoadingButton from '@mui/lab/LoadingButton'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import PictureAsPdf from '@mui/icons-material/PictureAsPdf';
import "../styles/ToolTip.css";

export const EjesPDFButtons = ({ loading, setLoading, eje, listaEjes, activarEjeFunction, anularEjeFunction, GetCuestionarioReportEje, reiniciarEjeFunction, goToTema }) => {

    const { t } = useTranslation()

    const IconButton = styled(Button)(({ theme }) => ({
        padding: '6px 6px',
        minWidth: '35px',
        height: '35px',
    }));

    return (
        <Stack direction="row" marginY={1} gap={1} justifyContent={!eje.disable ? "space-between" : "flex-start"}>
            <Stack direction="row" gap={1}>
                {eje.porcentaje == 100 && (
                    <>
                        <BotonPDF className="botonPDF">
                            
                                <LoadingButton
                                    onClick={() => {
                                        setLoading(true);
                                        GetCuestionarioReportEje(listaEjes.id_cuestionario, eje);
                                    }}
                                    sx={{ paddingBottom: "0.36em", paddingTop: "0.36em" }}
                                    loading={loading}
                                    variant="contained"
                                    endIcon={<PictureAsPdf sx={{ color: colors.textMain }} />}
                                    loadingPosition="end"
                                >
                                    PDF
                                </LoadingButton>
                            
                        </BotonPDF>
                        <ToolTipBoton
                            className="botonHover"
                            titulo={t("eje.pdfTooltipTitle")}
                            body={t("eje.pdfTooltipBody")}
                        ></ToolTipBoton>
                    </>
                )}
                {!eje.disable && (
                    <>
                        <IconButton className="botonContinuar" variant='contained' onClick={() => { goToTema(eje.id_eje) }}>
                            <ArrowForwardIcon sx={{ color: colors.textMain }} />
                        </IconButton>
                        <ToolTipBoton
                            className="botonHoverContinuar"
                            titulo={t("eje.continuarTooltipTitle")}
                            body={t("eje.continuarTooltipBody")}
                        ></ToolTipBoton>
                    </>
                )}
            </Stack>
            <Stack direction="row" gap={1}>
                {eje.porcentaje > 0 && (
                    <>
                        <ModalConfirmar
                            useDiv //Para que no envuelva en un boton el children
                            title={t("eje.modalReinciarEjesTitulo")}
                            text={t("eje.modalReiniciarEjesTexto")}
                            cancelText={t("general.cancelar")}
                            continueText={t("misCuestionarios.continuar")}
                            onContinue={() => { reiniciarEjeFunction(eje.id_eje) }}
                            deshabilitar={true}
                        >
                            <IconButton className="botonReiniciar" color={"error"} variant='contained'>
                                <ReplayIcon sx={{ color: colors.textMain }} />
                            </IconButton>
                            <ToolTipBoton
                                className="botonReiniciarHover"
                                titulo={t("eje.reiniciarTooltipTitle")}
                                body={t("eje.reiniciarTooltipBody")}
                            ></ToolTipBoton>
                        </ModalConfirmar>
                    </>
                )}
                {!eje.disable ? (
                    <>
                        <ModalConfirmar
                            useDiv
                            title={t("eje.desactivarEjePregunta")}
                            text={t("eje.desactivarEjeBody")}
                            cancelText={t("general.cancelar")}
                            continueText={t("misCuestionarios.continuar")}
                            onContinue={() => { anularEjeFunction(eje.id_eje) }}
                            deshabilitar={true}
                            envuelveBoton={listaEjes.isMaxAnulados}
                        >
                            
                            <IconButton className="botonAnular" color={listaEjes.isMaxAnulados ? "inherit" : "error"} variant='contained' >
                                <ClearIcon sx={{ color: listaEjes.isMaxAnulados ? colors.darkDisable : colors.textMain }} />
                            </IconButton>
                            <ToolTipBoton
                                titulo={listaEjes.isMaxAnulados ? t("eje.maxAnuladosTitle").toUpperCase() : t("eje.anularEjeTooltipTitle")}
                                body={listaEjes.isMaxAnulados ? t("eje.maxAnuladosBody") : t("eje.anularEjeTooltipBody")}
                                className="botonAnularHover"
                            ></ToolTipBoton>
                        </ModalConfirmar>

                    </>
                ) : (
                    <>
                        <IconButton className="botonActivar" color={"error"} variant='contained' onClick={() => { activarEjeFunction(eje.id_eje) }}>
                            <PowerSettingsNewIcon sx={{ color: colors.textMain }} />
                        </IconButton>
                        <ToolTipBoton
                            titulo={t("eje.activarEjeTooltipTitle")}
                            body={t("eje.activarEjeTooltipBody")}
                            className="botonActivarHover"
                        ></ToolTipBoton>
                    </>
                )}
            </Stack>
        </Stack>
    )
}
